import { useTranslation } from 'react-i18next';
import { Button, GoogleFontIcon } from '@asset-metrix/portal-ui';
import { useDisclosure } from '@mantine/hooks';

import { usePageEditModeStore } from '../../store/states/pageEditMode';
import { AddComponentToDashboardModal } from '../customizableDashboard/AddComponentToDashboardModal';

import styles from './pageHeaderActions.module.scss';

export function PageEditActions() {
  const { t } = useTranslation();
  const editModePageId = usePageEditModeStore((state) => state.editModePageId);
  const savePageEdit = usePageEditModeStore((state) => state.savePageEdit);
  const [
    addComponentsOpened,
    { close: closeAddComponents, open: openAddComponents },
  ] = useDisclosure(false);

  return (
    <div className={styles['actions']}>
      <Button
        variant="secondary"
        icon={<GoogleFontIcon name="archive" />}
        title={t('app.page.editAction.label.archive')}
      >
        {t('app.page.editAction.label.archive')}
      </Button>
      <Button
        variant="secondary"
        icon={<GoogleFontIcon name="delete" />}
        title={t('app.page.editAction.label.delete')}
      >
        {t('app.page.editAction.label.delete')}
      </Button>
      <Button
        variant="secondary"
        icon={<GoogleFontIcon name="ios_share" />}
        title={t('app.page.editAction.label.share')}
      >
        {t('app.page.editAction.label.share')}
      </Button>
      <Button
        variant="primary"
        icon={<GoogleFontIcon name="add" />}
        title={t('app.page.editAction.label.addComponent')}
        onClick={() => {
          if (editModePageId == null) {
            return;
          }
          openAddComponents();
        }}
      >
        {t('app.page.editAction.label.addComponent')}
      </Button>
      <Button
        variant="primary"
        icon={<GoogleFontIcon name="save" />}
        title={t('app.page.editAction.label.save')}
        onClick={savePageEdit}
      >
        {t('app.page.editAction.label.save')}
      </Button>
      <AddComponentToDashboardModal
        onAddComponents={() => undefined} // API endpoint not yet created
        onClose={closeAddComponents}
        opened={addComponentsOpened}
      />
    </div>
  );
}
